import React from "react";
import UpdatePasswordForm from "./UpdatePasswordForm";
import UpdateProfileForm from "./UpdateProfileForm";
import UpdateEmailForm from "./UpdateEmailForm";

export default function AccountSettingsComponent() {
  return (
    <div className="w-full max-w-6xl">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-start">
      <UpdateEmailForm />
        <UpdatePasswordForm />
        <UpdateProfileForm />
      </div>
    </div>
  );
}
